import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {ConceptSelection, DisplayField, DisplayTerm, Term} from '@twpub/core/models';
import {NGXLogger} from 'ngx-logger';

import {FieldRenderComponent} from '../field-render/field-render.component';

@Component({
  selector: 'pub-term-render',
  templateUrl: './term-render.component.html',
  styleUrls: ['./term-render.component.scss'],
  standalone: true,
  imports: [FieldRenderComponent]
})
export class TermRenderComponent implements OnChanges {
  @Input() term?: DisplayTerm | Term
  @Input() focus: boolean = false;
  @Input() type: string = '';
  @Input() showLang: boolean = false;

  @Output() conceptSelected = new EventEmitter<ConceptSelection>()
  tidField!: DisplayField;
  termNameField!: DisplayField;
  regionField?: DisplayField;
  scriptField?: DisplayField;
  termFields: DisplayField[] = [];
  termClass: string = 'term';

  constructor(private logger: NGXLogger) {
  }

  ngOnChanges() {
    const termName = (this.term?.name || '') + (this.showLang ? ` (${this.term?.languageCode || ''})` : '');
    const termCssStyle = this.term && 'cssStyle' in this.term
      ? (this.term as DisplayTerm).cssStyle
      : this.term && 'fieldStyles' in this.term ? (this.term as Term).fieldStyles?.['term'] : undefined;
    this.termNameField = {oid: 'term', jsonField: 'term', label: 'Term', value: termName, cssStyle: termCssStyle};
    this.termClass = 'term' + (this.term?.rtl ? ' rtl' : '');
    this.regionField = this.term?.regionCode?.length
      ? {
          oid: 'GVAR',
          jsonField: 'GVAR',
          label: 'region',
          value: this.term.regionCode.toUpperCase()
        }
      : undefined;
    this.scriptField = this.term?.scriptCode?.length
      ? {
          oid: 'OVAR',
          jsonField: 'OVAR',
          label: 'script',
          value: this.term.scriptCode
        }
      : undefined;

    if (this.term && 'fields' in this.term) {
      this.tidField = {oid: 'tid', jsonField: 'tid', label: 'Term ID', value: this.term?.tid || ''};
      this.termFields = (this.term as DisplayTerm).fields || [];
    }
  }

  selectConcept(selection: ConceptSelection) {
    this.logger.trace('TermRenderComponent.selectConcept:', {selection})
    this.conceptSelected?.emit(selection);
  }
}
